"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/// <reference types="jquery"/>
var vue_1 = __importDefault(require("vue"));
var form_checkbox_1 = __importDefault(require("bootstrap-vue/es/components/form-checkbox/form-checkbox"));
var ConditionalDisplay_1 = __importDefault(require("../../Mixins/ConditionalDisplay"));
var PredicateInput_1 = __importDefault(require("../../Mixins/PredicateInput"));
exports.default = vue_1.default.extend({
    props: ['name', 'label', 'required', 'selected', 'inline', "sourceType", "sourceTarget"],
    mixins: [ConditionalDisplay_1.default, PredicateInput_1.default],
    components: { bFormCheckbox: form_checkbox_1.default },
    data: function () {
        var model = this.$root.$data;
        var sourceValue;
        return {
            value: model.data != null && model.data[this.name]
                ? model.data[this.name]
                : this.sourceType && (sourceValue = model.dataStore[this.sourceType.toLowerCase() + "_" + this.sourceTarget])
                    ? JSON.parse(sourceValue)
                    : this.selected
                        ? JSON.parse(this.selected)
                        : false,
            readonly: model.readOnly
        };
    },
    methods: {
        getPredicateValue: function () {
            return this.value ? "true" : "false";
        },
        getClass: function () {
            return this.inline && JSON.parse(this.inline) ? "d-inline-block ml-2" : "";
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Input/CheckBox.vue
// module id = 197
// module chunks = 0